module.exports = __webpack_public_path__ + "img/IMG_7282.c17f354a.jpg";